import React from 'react';
import '../../App.css';

class Loader extends React.Component {
    render() {
        return (
            <div style={{display:"flex", justifyContent:"center", overflow:"hidden", ...this.props.style }}>
                <div className="c-loader" 
                    style={{
                        borderTopColor: this.props.color ? this.props.color : "#ccc", 
                        borderBottomColor: this.props.color ? this.props.color : "#ccc", 
                        borderRightColor: "transparent", borderLeftColor:"transparent",
                        width: this.props.size ? this.props.size : 15,
                        height: this.props.size ? this.props.size : 15,
                        borderWidth: this.props.borderWidth ? this.props.borderWidth : 3}}>
                </div>
                <span style={{color:this.props.color ? this.props.color : "#ccc", marginLeft:10}}>Loading...</span>
            </div>
        );
    }
}

export default Loader